import { TextLabel } from '@core/components/Inputs';
import { DataBR, formatCNPJ, formatCPF } from '@format';
import { Grid } from '@material-ui/core';
import { Logomarca } from 'app/assets/logomarca';
import { GlobalContext } from 'app/store/globalcontext';
import React, { useContext } from 'react';
import { Comercializacao, IndicadorInsricaoEstadual } from '../enums';

const DadosGeraisVisualizar = ({ dadosGerais }) => {
  const [empresa] = useContext(GlobalContext).empresa;

  const isPessoaJuridica = dadosGerais?.pessoa?.tipoPessoa === 'JURIDICA';

  return (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        {empresa?.logomarca ? <img src={empresa?.logomarca} alt="" /> : <img src={Logomarca} alt="" />}
      </Grid>
      <Grid item xs={9}>
        <TextLabel label="Nome" value={dadosGerais?.pessoa?.nome} />
        {isPessoaJuridica ? (
          <TextLabel label="CNPJ" value={dadosGerais?.pessoa?.pessoaJuridica?.cnpj} format={formatCNPJ} />
        ) : (
          <TextLabel label="CPF" value={dadosGerais?.pessoa?.pessoaFisica?.cpf} format={formatCPF} />
        )}
      </Grid>
      {isPessoaJuridica ? (
        <>
          <Grid item xs={12}>
            <TextLabel label="Razão Social" value={dadosGerais?.pessoa?.pessoaJuridica?.razaoSocial} />
          </Grid>
          <Grid item xs={6}>
            <TextLabel label="Principal atividade econômica" value={dadosGerais?.cnae?.descricao} />
          </Grid>
          <Grid item xs={6}>
            <TextLabel label="Data da fundação" value={DataBR(dadosGerais?.pessoa?.pessoaJuridica?.dataFundacao)} />
          </Grid>
          <Grid item xs={6}>
            <TextLabel
              label="Indicador de inscrição estadual"
              value={IndicadorInsricaoEstadual[dadosGerais?.pessoa?.pessoaJuridica?.indicadorInscricaoEstadual]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextLabel label="Inscrição estadual" value={dadosGerais?.pessoa?.pessoaJuridica?.inscricaoEstadual} />
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={6}>
            <TextLabel label="Principal atividade econômica" value={dadosGerais?.cnae?.descricao} />
          </Grid>
          <Grid item xs={6}>
            <TextLabel label="Identidade" value={dadosGerais?.pessoa?.pessoaFisica?.identidade} />
          </Grid>
          <Grid item xs={6}>
            <TextLabel label="Data do nascimento" value={DataBR(dadosGerais?.pessoa?.pessoaFisica?.dataNascimento)} />
          </Grid>
          <Grid item xs={6}>
            <TextLabel
              label="Identificador estrangeiro"
              value={dadosGerais?.pessoa?.pessoaFisica?.identificadorEstrangeiro}
            />
          </Grid>
        </>
      )}
      <Grid item xs={6}>
        <TextLabel label="Inscrição municipal" value={dadosGerais?.pessoa?.inscricaoMunicipal} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel label="Comercialização" value={Comercializacao[dadosGerais?.comercializacao]} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel label="E-mail principal" value={dadosGerais?.emailPrincipal} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel label="Nome do remetente do e-mail" value={dadosGerais?.nomeRemetentePrincipal} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel label="E-mail cobrança" value={dadosGerais?.emailCobranca} />
      </Grid>
      <Grid item xs={6}>
        <TextLabel label="Nome do remetente do e-mail" value={dadosGerais?.nomeRemetenteCobranca} />
      </Grid>
      <Grid item xs={12}>
        <TextLabel label="Meu plano contratado" value={dadosGerais?.planoComercial?.nome} />
      </Grid>
    </Grid>
  );
};

export default DadosGeraisVisualizar;
